export const SERVICE_FAILURE = 'SERVICE_FAILURE';
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const ADD_ITEM_TO_CART_SUCCESS = 'ADD_ITEM_TO_CART_SUCCESS';
export const ADD_ITEM_TO_CART_FAILURE = 'ADD_ITEM_TO_CART_FAILURE';
export const UPDATE_CART = 'UPDATE_CART';
export const REMOVE_CART = 'REMOVE_CART';
export const REMOVE_CART_SUCCESS = 'REMOVE_CART_SUCCESS';
export const REMOVE_CART_FAILURE = 'REMOVE_CART_FAILURE';
export const UPDATE_CART_SUCCESS = 'UPDATE_CART_SUCCESS';
export const UPDATE_CART_FAILURE = 'UPDATE_CART_FAILURE';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const REMOVE_CART_ITEM_SUCCESS = 'REMOVE_CART_ITEM_SUCCESS';
export const REMOVE_CART_ITEM_FAILURE = 'REMOVE_CART_ITEM_FAILURE';
export const REQUEST_QUOTE = 'REQUEST_QUOTE';
export const REQUEST_QUOTE_SUCCESS = 'REQUEST_QUOTE_SUCCESS';
export const BULK_ADD_ITEM_TO_CART = 'BULK_ADD_ITEM_TO_CART';
export const BULK_ADD_ITEM_TO_CART_SUCCESS = 'BULK_ADD_ITEM_TO_CART_SUCCESS';
export const DOWNLOAD_CSV_SUCCESS = 'DOWNLOAD_CSV_SUCCESS';
export const INVALID_SKU_ERROR = 'invalidSkuError';
export const SHOW_ORDER_NOT_AVAILABLE = 'SHOW_ORDER_NOT_AVAILABLE';
export const SHOW_BLOCKED_ACCOUNT_MODAL = 'SHOW_BLOCKED_ACCOUNT_MODAL';
export const RESET_CART_ERROR_MESSAGE = 'RESET_CART_ERROR_MESSAGE';
export const CREATE_REQUISITION = 'CREATE_REQUISITION';
export const REQUISITION_SUBMIT_SUCCESS = 'REQUISITION_SUBMIT_SUCCESS';
export const SHARE_CART_SUBMIT = 'SHARE_CART_SUBMIT';
export const SHARE_CART_SUBMIT_SUCCESS = 'SHARE_CART_SUBMIT_SUCCESS';
export const SHARE_CART_MODAL_ANALYTICS = 'SHARE_CART_MODAL_ANALYTICS';
export const SHARE_CART_CLEAR = 'SHARE_CART_CLEAR';

export const PRODUCT_REFERENCES = {
  DiscontinueNoReplacement: 'DiscontinueNoReplacement',
  ObsoleteNoReplacement: 'ObsoleteNoReplacement',
};
export const PRODUCT_REFERENCES_WITH_REPLACEMENT = {
  DiscontinueWithReplacement: 'DiscontinueWithReplacement',
  ObsoleteWithReplacement: 'ObsoleteWithReplacement',
};
export const REQUISITION_SUBMIT_ERROR = 'requisitionSubmitError';

export const BASIC = 'BASIC';
export const FULL = 'FULL';
export const VALIDATE_QUOTE_CODE = 'VALIDATE_QUOTE_CODE';
export const QUOTE_DETAIL_FAILURE = 'QUOTE_DETAIL_FAILURE';

export const QUOTE_STATUS = {
  open: 'Open',
  pending: 'Pending',
  rejected: 'Rejected',
  expired: 'Expired',
  orderPlaced: 'Order Placed',
  quoteReplaced: 'Quote Replaced',
};

export const QUOTE_NOT_FOUND_ERROR = 'quoteNotFoundError';
export const QUOTE_NO_LONGER_OPEN_ERROR = 'quoteNoLongerOpenError';
export const REQUEST_QUOTE_CLICK = 'REQUEST_QUOTE_CLICK';
export const SHARE_CONFIRMATION_SUBMIT = 'SHARE_CONFIRMATION_SUBMIT';
export const SHARE_CONFIRMATION_SUBMIT_SUCCESS = 'SHARE_CONFIRMATION_SUBMIT_SUCCESS';
export const SHARE_CONFIRMATION_CLEAR = 'SHARE_CONFIRMATION_CLEAR';
export const LOAD_ACCOUNT_DATA = 'LOAD_ACCOUNT_DATA';
